module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"fassadeTileTitle":"Fassadenfläche","fassadeTileArea":"Fläche","fassadeTileIrradiation":"Jährliche Einstrahlung","fassadeTileOrientation":"Orientierung","fassadeTileClass":"Eignung für PV","fassadeTileClass_5":"Top","fassadeTileClass_4":"Sehr gut","fassadeTileClass_3":"Gut","fassadeTileClass_2":"Mittel","fassadeTileClass_1":"Gering","fassadeTileClass_small":"Zu Klein"}}')
  delete Component.options._Ctor
}
